import type { BaseKeyFunction } from "../../../lib";

export const keyPlans: BaseKeyFunction = () => ["plans"];

export const keyGiftCards: BaseKeyFunction = () => ["gift-cards"];
